export const JobRecurValidation = (formData) => {
    const errors = {};
    if (!formData.snt_FrequencyAmount) {
        errors.snt_FrequencyAmount = 'This field is required';
    }
    if (formData.snt_RecurType === "1") {
        if (!formData.snt_RecurEntries) {
            errors.snt_RecurEntries = 'This field is required';
        }
    }
    if (!formData.dt_Begin) {
        errors.dt_Begin = 'This field is required';
    }
    if (!formData.dt_Begin_Time) {
        errors.dt_Begin_Time = 'This field is required';
    }
    return errors;
};